import { assignInlineVars } from "@vanilla-extract/dynamic";

import magicSparklesSvg from "../../img/magic-sparkles.svg";
import { tokens } from "../../styles/theme.css";
import { Svg } from "../../utils/svgIcon";

import * as styles from "./AiMagicSparkles.css";

export interface AiMagicSparklesProps {
    size?: number;
}

export function AiMagicSparkles({ size }: AiMagicSparklesProps) {
    return (
        <div
            className={styles.container}
            style={assignInlineVars({
                [styles.sizeVar]: size ? `${size}px` : tokens.sizing.iconLarge,
            })}
        >
            <Svg src={magicSparklesSvg} className={styles.icon} />
        </div>
    );
}
